import {
  FoodScoreResult,
  FoodScoreTypeName,
} from '../../../../interfaces/FoodScorePageResponse';

export const getDefaultValue = (
  foodScoreResultList: FoodScoreResult[],
  foodScoreType: FoodScoreTypeName,
) => {
  if (!foodScoreResultList?.length) {
    return null;
  }

  const foodScore = foodScoreResultList.find(
    (score) => score.foodScoreType === foodScoreType,
  );

  return foodScore?.foodScoreValue ?? null;
};
